import { render, staticRenderFns } from "./UnderDevelopment.vue?vue&type=template&id=e0a959e2&"
var script = {}
import style0 from "./UnderDevelopment.vue?vue&type=style&index=0&id=e0a959e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports